import TrashUsers from './TrashUsers';

export default TrashUsers;
